<template>
  <section class="section">
    <div class="section-body">
      <form>
        <v-expansion-panels
          v-model="panel"
          style="height: 100%; border-radius: 0 !important"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div style="display: flex; align-items: center;">
                <v-icon color="pink">search</v-icon>
                <div style="font-size: 16px !important;">
                  {{ $t("messages.general.searchShowInfo") }}
                </div>
              </div></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-card width="100%">
                <v-row>
                  <v-col
                    cols="10"
                    style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
                  >
                    <p style="color: red; margin: 0">*</p>
                  </v-col>
                  <v-col
                    style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
                  >
                    <p style="margin: 0">
                      {{ $t("messages.general.reqFields") }}
                    </p>
                  </v-col>
                </v-row>
              </v-card>
              <div class="row">
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.academicYear") }}
                            <code style="background: none; box-shadow: none;"
                              >*</code
                            ></label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <AcademicYear
                            :onChanged="onSelYearChanged"
                            :selectedVal="selYear"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.semester")
                            }}<code style="background: none; box-shadow: none;"
                              >*</code
                            >
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <Semester
                            :onChanged="onSelSemesterChanged"
                            :selectedVal="selSemester"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.educationLvl") }}
                            <code style="background: none; box-shadow: none;"
                              >*</code
                            ></label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <Level
                            :onChanged="onSelLvlChanged"
                            :selectedVal="selLvl"
                            :disabled="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.yearPlan") }}
                            <code style="background: none; box-shadow: none;"
                              >*</code
                            >
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <AcademicYear
                            :onChanged="onSelAdmitYearChanged"
                            :selectedVal="selAdmitYear"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.prevTerm") }}
                            <code style="background: none; box-shadow: none;"
                              >*</code
                            ></label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <Semester
                            :onChanged="onSelAdmitSemesterChanged"
                            :selectedVal="selAdmitSemester"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label>{{ $t("messages.general.faculty") }} </label>
                        </div>
                        <div class="col no-margin-padding">
                          <Faculty
                            :onChanged="onSelFacultyChanged"
                            :selectedVal="selFaculty"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label style="white-space: pre-line"
                            >{{ $t("messages.general.from") }}
                            {{ $t("messages.general.identity") }}</label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <input
                            type="number"
                            min="0"
                            class="form-control col mr-2"
                            style="text-align:right"
                            v-model="studentfrom"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.to") }}
                            {{ $t("messages.general.identity") }}</label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <input
                            type="number"
                            min="0"
                            class="form-control col mr-2"
                            style="text-align:right"
                            v-model="studentto"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label>{{
                            $t("messages.general.educationYear")
                          }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <select class="form-control" v-model="selectedYear">
                              <option
                                v-for="(opt, idx) in selectedYearOpts"
                                v-bind:key="idx"
                                v-bind:value="opt.value"
                              >
                                {{ opt.text }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label>{{
                            $t("messages.general.educationCourse")
                          }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div class="form-row">
                            <div
                              class="col no-margin-padding"
                              style="flex: 0 0 8em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                            >
                              <div class="form-group" style="margin-bottom: 0;">
                                <div class="input-group">
                                  <div class="form-inline">
                                    <div class="input-group-append">
                                      <input
                                        type="text"
                                        class="form-control col mr-2"
                                        style="margin-right: 0px !important; width: 100px !important; max-width: 100px !important"
                                        v-model="txtProgramCode"
                                        @keypress="
                                          handleSearchProgramKey($event)
                                        "
                                      />
                                      <button
                                        class="btn btn-primary btn-lg"
                                        type="button"
                                        @click="handleSearchProgram()"
                                      >
                                        <i class="fas fa-search"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col no-margin-padding"
                              style="flex: 0 0 17em;"
                            >
                              <div class="form-group" style="margin-bottom: 0;">
                                <div class="input-group">
                                  <div class="form-inline">
                                    <div class="input-group-append">
                                      <input
                                        type="text"
                                        class="form-control col mr-2"
                                        style="margin-right: 0px !important; width: 100%;"
                                        v-model="txtProgramName"
                                        disabled
                                      />
                                      <button
                                        class="btn btn-danger btn-lg"
                                        type="button"
                                        @click="clearSelectProgram()"
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.classCodeGroup") }}
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <select
                              class="form-control"
                              v-model="selCoursegroup"
                            >
                              <option
                                v-for="(opt, idx) in selectedCourseGroupOpts"
                                v-bind:key="idx"
                                v-bind:value="opt.value"
                              >
                                {{ opt.text }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.from") }}
                            {{ $t("messages.general.status") }}</label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <StudentStatus
                            :onChanged="onSelStudentStatusSearchFromChanged"
                            :selectedVal="selStudentStatusSearchFrom"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 8em;"
                        >
                          <label
                            >{{ $t("messages.general.to") }}
                            {{ $t("messages.general.status") }}</label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <StudentStatus
                            :onChanged="onSelStudentStatusSearchToChanged"
                            :selectedVal="selStudentStatusSearchTo"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div
          class="form-row flex-column justify-content-center align-items-center mt-5"
        >
          <div class="form-group" style="width: 100%">
            <div class="form-inline">
              <div
                class="form-group"
                style="width: 60%; justify-content: center;"
              >
                <div class="form-inline"></div>
              </div>
              <div
                class="form-group"
                style="width: 100%; justify-content: flex-end;"
              >
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchStudent()"
                    :disabled="this.stucode != ''"
                  >
                    {{ $t("messages.general.pullStudentName") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="pullCourse()"
                    :disabled="bTableStudent.items.length <= 0"
                  >
                    {{ $t("messages.general.pullCourse") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="regisClsList()"
                    :disabled="bTableStudent.items.length <= 0"
                  >
                    {{ $t("messages.general.regischk") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col">
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label>{{ $t("messages.general.selStuGroup") }}</label>
                </div>
                <div class="col no-margin-padding" style="flex: 0 0 18em;">
                  <input
                    type="file"
                    ref="csvFile"
                    class="form-control"
                    @change="handleCsvFileChg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        style="padding: 10px; box-shadow: rgb(0 0 0 / 10%) 1px 1px 1px 1px; border: 1px solid lightgray; border-radius: 5px; padding-bottom: 0px;"
      >
        <div class="row" style="margin: 10px !important;">
          <div class="col-6" style="padding-right: 35px !important;">
            <div class="row">
              <div class="col no-margin-padding" style="flex: 0 0 8em;">
                <label>{{ $t("messages.general.studentListName") }} </label>
              </div>
            </div>
            <div class="row">
              <div class="col no-margin-padding">
                <!-- ตารางรายชื่อนศ -->
                <v-card>
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="fullsize table table-striped text-center"
                    :sort-by.sync="bTableStudent.sortBy"
                    :sort-desc.sync="bTableStudent.sortDesc"
                    :items="bTableStudent.items"
                    :fields="bTableStudent.fields"
                    style="height: 300px !important"
                  >
                    <template v-slot:cell(STUDENTCODE)="data">
                      <!-- <a
                            @click="
                              handleSelStudentCode(data.item, data.index)
                            "
                            style="text-decoration: underline;"
                          >
                            {{ data.item.STUDENTCODE }}
                          </a> -->
                      <input
                        :ref="`ref_txtStudentCode_${data.item.rowNumber}`"
                        class="form-control"
                        :value="data.item.STUDENTCODE"
                        @keydown="handleTxtStuKeyChange($event, data)"
                        @focus="handleSelStudentCode(data.item, data.index)"
                      />
                    </template>
                  </b-table>
                </v-card>
              </div>
            </div>
          </div>
          <div class="col-6" style="padding-left: 5px !important;">
            <div class="row">
              <div class="col no-margin-padding" style="flex: 0 0 9em;">
                <label>{{ $t("messages.general.listClsByOne") }} </label>
              </div>
            </div>
            <div class="row">
              <div class="col no-margin-padding">
                <div>
                  <v-card>
                    <b-table
                      bordered
                      hover
                      small
                      responsive
                      caption-top
                      class="fullsize table table-striped text-center"
                      :sort-by.sync="bTableClsStudentByOne.sortBy"
                      :sort-desc.sync="bTableClsStudentByOne.sortDesc"
                      :items="bTableClsStudentByOne.items"
                      :fields="bTableClsStudentByOne.fields"
                      style="height: 300px !important"
                    >
                    </b-table>
                  </v-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <div class="row">
        <v-tabs v-model="selTab">
          <v-tab href="#tab-1">{{
            $t("messages.general.listCouseforset")
          }}</v-tab>
          <v-tab href="#tab-2">{{
            $t("messages.general.cancelListError")
          }}</v-tab>
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-card-text>
                <v-sheet>
                  <v-card>
                    <b-table
                      bordered
                      hover
                      small
                      responsive
                      caption-top
                      class="table table-striped text-center"
                      :sort-by.sync="bTablelistSetCls.sortBy"
                      :sort-desc.sync="bTablelistSetCls.sortDesc"
                      :items="bTablelistSetCls.items"
                      :fields="bTablelistSetCls.fields"
                      :per-page="perPage"
                      :current-page="currentPage"
                    >
                      <template v-slot:cell(action)="data">
                        <v-btn
                          v-if="data.item.rowNumber == 0"
                          icon
                          @click="handleAddItem(data.item, data.index)"
                        >
                          <v-icon>save</v-icon></v-btn
                        >
                        <v-btn
                          v-if="data.item.rowNumber != 0"
                          icon
                          @click="handleDelItem(data.item, data.index)"
                        >
                          <v-icon>delete</v-icon></v-btn
                        >
                      </template>
                      <template v-slot:cell(LVL)="data">
                        <span v-if="data.item.rowNumber == 0">{{
                          selLvl
                        }}</span>
                        <span v-if="data.item.rowNumber != 0">{{
                          data.item.LVL
                        }}</span>
                      </template>
                      <template v-slot:cell(ACTION_STATUS)="data">
                        <select
                          v-if="data.item.rowNumber == 0"
                          class="form-control"
                          @change="onDdlChg($event)"
                          :style="style"
                        >
                          <option selected value="-1"
                            >---{{
                              $t("messages.general.notSpecified")
                            }}---</option
                          >
                          <option
                            v-for="(item, index) in ddlItem"
                            :key="index"
                            :value="item.BYTECODE"
                            :selected="ddlVal == item.BYTECODE"
                          >
                            {{ item.ACTION }}
                          </option>
                        </select>
                        <span v-if="data.item.rowNumber != 0">{{
                          data.item.ACTION_STATUS
                        }}</span>
                      </template>
                      <template v-slot:cell(CLASSID)="data">
                        <input
                          v-if="data.item.rowNumber == 0"
                          type="text"
                          min="0"
                          class="form-control col mr-2"
                          style="text-align:left;"
                          v-model="clsId"
                          @keydown="handleSearchOpenCourse($event, data.item)"
                        />
                        <span v-if="data.item.rowNumber != 0">{{
                          data.item.CLASSID
                        }}</span>
                      </template>
                      <template v-slot:cell(SECTION_TEXT)="data">
                        <select
                          v-if="data.item.rowNumber == 0"
                          class="form-control"
                          @change="onDdlSectionChg($event)"
                          :style="style"
                        >
                          <option selected value="-1"
                            >---{{
                              $t("messages.general.notSpecified")
                            }}---</option
                          >
                          <option
                            v-for="(item, index) in ddlSection"
                            :key="index"
                            :value="item.val"
                            :selected="ddlSectionVal == item.val"
                          >
                            {{ item.txt }}
                          </option>
                        </select>
                        <span v-if="data.item.rowNumber != 0">{{
                          data.item.SECTION_TEXT
                        }}</span>
                      </template>
                      <template v-slot:cell(REASON_TEXT)="data">
                        <input
                          v-if="data.item.rowNumber == 0"
                          type="text"
                          min="0"
                          class="form-control col mr-2"
                          style="text-align:left;"
                          v-model="reasonCls"
                        />
                        <span v-if="data.item.rowNumber != 0">{{
                          data.item.REASON_TEXT
                        }}</span>
                      </template>
                    </b-table>
                  </v-card>
                </v-sheet>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card>
              <b-table
                bordered
                hover
                small
                responsive
                caption-top
                class="table table-striped text-center"
                :sort-by.sync="bTableConditionsCtrlEnroll.sortBy"
                :sort-desc.sync="bTableConditionsCtrlEnroll.sortDesc"
                :items="bTableConditionsCtrlEnroll.items"
                :fields="bTableConditionsCtrlEnroll.fields"
                :per-page="perPage"
                :current-page="currentPage"
                style="position: relative;"
              >
                <template slot="table-caption">
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableConditionsCtrlEnroll.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                  />
                  <div
                    v-if="bTableConditionsCtrlEnroll.items.length > 0"
                    class="float-right data-table-page-info"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage >
                          bTableConditionsCtrlEnroll.items.length
                          ? bTableConditionsCtrlEnroll.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(
                        bTableConditionsCtrlEnroll.items.length
                      ).toLocaleString()
                    }}
                  </div>
                  <div
                    v-if="bTableConditionsCtrlEnroll.items.length <= 0"
                    class="float-right data-table-page-info"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(
                        bTableConditionsCtrlEnroll.items.length
                      ).toLocaleString()
                    }}
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <input
                    type="checkbox"
                    id="chkDel"
                    @change="handleCondtionChk($event, data)"
                    :checked="data.value"
                  />
                </template>
                <template slot="table-caption">
                  <div
                    style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                  >
                    <div class="float-left">
                      <b class="mr-2">{{
                        $t("messages.general.table.paginationinfo")
                      }}</b>
                      <b-form-select
                        v-model="perPage"
                        :options="perPageOptions"
                        size="sm"
                        style="width:70px"
                      />
                    </div>
                    <b-pagination
                      class="float-right"
                      size="sm"
                      :total-rows="bTableConditionsCtrlEnroll.items.length"
                      v-model="currentPage"
                      :per-page="perPage"
                      style="padding-top: 10px"
                    />
                    <div
                      v-if="bTableConditionsCtrlEnroll.items.length > 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      {{
                        Number(
                          currentPage > 1
                            ? (currentPage - 1) * perPage + 1
                            : currentPage
                        ).toLocaleString()
                      }}
                      -
                      {{
                        Number(
                          currentPage * perPage >
                            bTableConditionsCtrlEnroll.items.length
                            ? bTableConditionsCtrlEnroll.items.length
                            : currentPage * perPage
                        ).toLocaleString()
                      }}
                      {{ $t("messages.general.fromRecords") }}
                      {{
                        Number(
                          bTableConditionsCtrlEnroll.items.length
                        ).toLocaleString()
                      }}
                    </div>
                    <div
                      v-if="bTableConditionsCtrlEnroll.items.length <= 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      0 - 0
                      {{ $t("messages.general.fromRecords") }}
                      {{
                        Number(
                          bTableConditionsCtrlEnroll.items.length
                        ).toLocaleString()
                      }}
                    </div>
                  </div>
                </template>
              </b-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </div>
      <!-- Success Dialog -->
      <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
        <v-card tile>
          <v-toolbar flat dense color="light-green accent-3">
            <v-icon color="light-green darken-2">fa-check</v-icon>
            <v-toolbar-title style="color: green;"
              >&nbsp;{{
                $t("messages.reqRegister.confirmPopupText")
              }}</v-toolbar-title
            >
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogConfirmSuccess = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark color="green accent-1">
            <br />
            <span v-html="successText" style="color: green;">{{
              successText
            }}</span>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Error Dialog -->
      <v-dialog v-model="dialogError" max-width="600px">
        <v-card tile>
          <v-toolbar flat dense color="red darken-3">
            <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
            <v-toolbar-title style="color: #ffebee;"
              >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
            >
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogError = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark color="red accent-1">
            <br />
            <span style="color: red;">{{ errorText }}</span>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSearchProgram"
        hide-overlay
        scrollable
        max-width="80%"
      >
        <v-card tile>
          <v-toolbar flat dense>
            <v-icon>search</v-icon>
            <v-toolbar-title>{{
              $t("messages.general.programNameList")
            }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogSearchProgram = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark>
            <form>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.programcode") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgProgramCode"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.programName") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgProgramName"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.faculty") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <Faculty
                        :onChanged="onSelFacultyProgramChanged"
                        :selectedVal="selFacultyProgram"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.department") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <Department
                        :onChanged="onSelDepartmentProgramChanged"
                        :facultyid="selFacultyProgram"
                        :selectedVal="selDepartmentProgram"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.educationLvl") }} </label>
                    </div>
                    <div class="col no-margin-padding">
                      <Level
                        :onChanged="onSelLvlProgramChanged"
                        :selectedVal="selLvlProgram"
                        :disabled="false"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.yearRef") }} </label>
                    </div>
                    <div class="col no-margin-padding">
                      <AcademicYear
                        :onChanged="onSelYearProgramChanged"
                        :selectedVal="selYearProgram"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-row flex-column justify-content-center align-items-center mt-5"
              >
                <div class="form-group">
                  <div class="form-inline">
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      @click="handleProgramSearch(true)"
                    >
                      {{ $t("messages.general.search") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      class="btn btn-light btn-lg"
                      type="button"
                      @click="cleartSearchProgram()"
                    >
                      {{ $t("messages.general.clearScreen") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </form>
            <v-card>
              <b-table
                bordered
                hover
                small
                responsive
                caption-top
                class="table table-striped text-center"
                :sort-by.sync="bTableProgram.sortBy"
                :sort-desc.sync="bTableProgram.sortDesc"
                :items="bTableProgram.items"
                :fields="bTableProgram.fields"
                :per-page="perPage"
                :current-page="currentPageProgram"
              >
                <template slot="table-caption">
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </template>

                <template v-slot:cell(PROGRAMCODE)="data">
                  <a
                    @click="handleSelectProgram(data.item, data.index)"
                    style="text-decoration: underline;"
                  >
                    {{ data.item.PROGRAMCODE }}
                  </a>
                </template>

                <template slot="table-caption">
                  <div
                    style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                  >
                    <div class="float-left">
                      <b class="mr-2">{{
                        $t("messages.general.table.paginationinfo")
                      }}</b>
                      <b-form-select
                        v-model="perPage"
                        :options="perPageOptions"
                        size="sm"
                        style="width:70px"
                      />
                    </div>
                    <b-pagination
                      class="float-right"
                      size="sm"
                      :total-rows="bTableProgram.items.length"
                      v-model="currentPageProgram"
                      :per-page="perPage"
                      style="padding-top: 10px"
                    />
                    <div
                      v-if="bTableProgram.items.length > 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      {{
                        Number(
                          currentPageProgram > 1
                            ? (currentPageProgram - 1) * perPage + 1
                            : currentPageProgram
                        ).toLocaleString()
                      }}
                      -
                      {{
                        Number(
                          currentPageProgram * perPage >
                            bTableProgram.items.length
                            ? bTableProgram.items.length
                            : currentPageProgram * perPage
                        ).toLocaleString()
                      }}
                      {{ $t("messages.general.fromRecords") }}
                      {{ Number(bTableProgram.items.length).toLocaleString() }}
                    </div>
                    <div
                      v-if="bTableProgram.items.length <= 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      0 - 0
                      {{ $t("messages.general.fromRecords") }}
                      {{ Number(bTableProgram.items.length).toLocaleString() }}
                    </div>
                  </div>
                </template>
              </b-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { read, utils } from "xlsx";

import AcademicYear from "@/components/Dropdown/AcademicYear";
import Semester from "@/components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import StudentStatus from "@/components/Dropdown/StudentStatus";
import ClassProvider from "@/services/class_provider";
import EnrollProvider from "@/services/enroll_provider";
import MasterDataProvider from "@/services/masterData_provider";
import ClassType from "@/components/Dropdown/ClassType.vue";
import Department from "@/components/Dropdown/Department.vue";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();
const classProvider = new ClassProvider();

export default {
  name: "reqEnrollForSet",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    StudentStatus,
    ClassType,
    Department,
  },
  data() {
    return {
      panel: 0,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selFaculty: 0,
      isEdit: false,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      selAdmitYear: 0,
      selAdmitSemester: 0,
      selTab: "",
      masterConditionList: [],
      conditionList: [],
      dlgAddSelected: {
        classid: 0,
        courseCode: "",
        courseName: "",
        credit: "",
        grade: "",
        classTime: "",
        section: "",
        classStatus: "",
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 10,
      currentPage: 1,
      currentPageSearch: 1,
      currentPageProgram: 1,
      selectedYear: 0,
      selectedYearOpts: [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
      ],
      selCoursegroup: 0,
      selectedCourseGroupOpts: [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10", value: 10 },
        { text: "11", value: 11 },
        { text: "12", value: 12 },
        { text: "13", value: 13 },
        { text: "14", value: 14 },
        { text: "15", value: 15 },
        { text: "16", value: 16 },
        { text: "17", value: 17 },
        { text: "18", value: 18 },
        { text: "19", value: 19 },
        { text: "20", value: 20 },
        { text: "21", value: 21 },
        { text: "22", value: 22 },
        { text: "23", value: 23 },
        { text: "24", value: 24 },
        { text: "25", value: 25 },
        { text: "26", value: 26 },
        { text: "27", value: 27 },
        { text: "28", value: 28 },
        { text: "29", value: 29 },
        { text: "30", value: 30 },
      ],
      // dialogSearchClass: false,
      dlgAddSelCourseCode: "",
      dlgAddSelCourseName: "",
      dlgSearchClassSelFaculty: 0,
      dlgSearchClassSelDepartment: 0,
      dlgSearchClassSelClsType: "",
      dlgSearchClassSelLvl: 3,
      dlgProgramCode: "",
      dlgProgramName: "",
      selFacultyProgram: 0,
      selDepartmentProgram: 0,
      selLvlProgram: 0,
      selYearProgram: 0,
      txtProgramCode: "",
      txtProgramName: "",
      studentfrom: "",
      studentto: "",
      stucode: "",
      selStudentStatusSearchFrom: 0,
      selStudentStatusSearchTo: 0,
      dialogSearchProgram: false,
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMCODE",
            label: this.$t("messages.general.programcode"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMNAME",
            label: this.$t("messages.general.programName"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "PROGRAMYEAR",
            label: this.$t("messages.general.yearRef"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableStudent: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            // thStyle: "width: 50px",
            sortable: true,
            tdClass: "col-30",
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 130px",
            tdClass: "text-center col-50",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left col-200",
            sortable: true,
          },
          {
            key: "ERR_DESCSUBMIT",
            label: this.$t("messages.general.errorList"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
        ],
      },
      bTableClsStudentByOne: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 12px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "SECTION_TEXT",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp col-70",
            sortable: true,
          },
          {
            key: "ERR_DESC_ITEM",
            label: this.$t("messages.general.errorList"),
            thClass: "align-left",
            thStyle: "width: 200px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ],
      },
      bTablelistSetCls: {
        sortBy: "rowNumber",
        sortDesc: true,
        items: [
          {
            rowNumber: 0,
          },
        ],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 90px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "LVL",
            label: this.$t("messages.general.level"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-50",
            sortable: true,
          },
          {
            key: "ACTION_STATUS",
            label: this.$t("messages.general.setListCls"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-150",
            sortable: true,
          },
          {
            key: "CLASSID",
            label: this.$t("messages.general.code"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-120",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.courseName"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.cretditSub"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-100",
            sortable: true,
          },
          {
            key: "CREDITTOTAL",
            label: this.$t("messages.general.regisCredit"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-90",
            sortable: true,
          },
          {
            key: "SECTION_TEXT",
            label: this.$t("messages.general.groupsec"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-90",
            sortable: true,
          },
          {
            key: "REASON_TEXT",
            label: this.$t("messages.general.reason"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-90",
            sortable: true,
          },
        ],
      },
      bTableConditionsCtrlEnroll: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "ERRORID",
            label: this.$t("messages.general.idCondition"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "ERRORSTRING",
            label: this.$t("messages.general.condition"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 80px",
            sortable: true,
          },
        ],
      },
      ddlItem: [],
      ddlVal: "-1",
      clsId: "",
      reasonCls: "",
      searchClsId: "",
      txtCredittotal: "",
      txtGroup: "",
      //isInvestiagatd: false,
      ddlSection: [],
      ddlSectionVal: "",
      studentIdLst: [],
      studentlist: [],
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.showListCondition();
    this.loadDdl();
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
    },
    onSelAdmitYearChanged(event) {
      this.selAdmitYear = parseInt(event.target.value);
    },
    onSelAdmitSemesterChanged(event) {
      this.selAdmitSemester = parseInt(event.target.value);
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelFacultyChanged(event) {
      this.selFaculty = parseInt(event.target.value);
    },
    onSelFacultyProgramChanged(event) {
      this.selFacultyProgram = parseInt(event.target.value);
    },
    onSelDepartmentProgramChanged(event) {
      this.selDepartmentProgram = parseInt(event.target.value);
    },
    onSelLvlProgramChanged(event) {
      this.selLvlProgram = parseInt(event.target.value);
    },
    onSelYearProgramChanged(event) {
      this.selYearProgram = parseInt(event.target.value);
    },
    onSelStudentStatusSearchFromChanged(event) {
      this.selStudentStatusSearchFrom = parseInt(event.target.value);
    },
    onSelStudentStatusSearchToChanged(event) {
      this.selStudentStatusSearchTo = parseInt(event.target.value);
    },
    onDlgSearchClassSelFacultyChanged(event) {
      this.dlgSearchClassSelFaculty = parseInt(event.target.value);
    },
    onDlgSearchClassSelDepartmentChanged(event) {
      this.dlgSearchClassSelDepartment = parseInt(event.target.value);
    },
    onDlgSearchClassSelLvlChanged(event) {
      this.dlgSearchClassSelLvl = parseInt(event.target.value);
    },
    onDlgSearchClassSelClsTypeChanged(event) {
      this.dlgSearchClassSelClsType = parseInt(event.target.value);
    },
    onDdlChg(event) {
      this.ddlVal = event.target.value;
    },
    onDdlSectionChg(event) {
      this.ddlSectionVal = event.target.value;
      const tmp = this.bTablelistSetCls.items.map((t) => {
        if (t.rowNumber == 0) {
          return {
            ...t,
            SECTION_TEXT: event.target.value,
          };
        }
        return t;
      });
      this.bTablelistSetCls.items = tmp;
    },
    clearSelectProgram() {
      this.txtProgramCode = "";
      this.txtProgramName = "";
    },
    async handleSearchProgramKey(event) {
      if (event.charCode == 13) {
        this.dlgProgramCode = this.txtProgramCode;
        this.handleProgramSearch(false);
      }
    },
    handleSearchProgram() {
      this.cleartSearchProgram();
      this.dialogSearchProgram = true;
    },
    async handleProgramSearch(isPopup) {
      const result = await this.getPrograms();
      if (result.length > 0) {
        if (
          !isPopup &&
          (result.length == 1 || result[0].PROGRAMCODE == this.txtProgramCode)
        ) {
          this.txtProgramCode = result[0].PROGRAMCODE;
          this.txtProgramName = result[0].PROGRAMNAME;
        } else {
          this.dialogSearchProgram = true;
          this.bTableProgram.items = [];
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTableProgram.items.push(d);
            idx++;
          });
        }
      } else {
        this.dialogSearchProgram = true;
        this.bTableProgram.items = [];
      }
    },
    async getPrograms() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          lang: this.currentLang,
          programyear: this.selYearProgram,
          levelid: this.selLvl,
        },
      };
      if (this.selFacultyProgram != 0) {
        params.request.facultyid = this.selFacultyProgram;
      }
      if (this.selDepartmentProgram != 0) {
        params.request.departmentid = this.selDepartmentProgram;
      }
      if (this.dlgProgramCode != "") {
        params.request.programcode = this.dlgProgramCode;
      }
      if (this.dlgProgramName != "") {
        params.request.programname = this.dlgProgramName;
      }
      const result = await enrollProvider.getSearchProgram(params);
      this.togglePreLoader(false);
      return result;
    },
    cleartSearchProgram() {
      this.dlgProgramCode = "";
      this.dlgProgramName = "";
      this.selFacultyProgram = 0;
      this.selDepartmentProgram = 0;
      this.selLvlProgram = 3;
      this.selYearProgram = this.appInfo.data.ENROLL_ACADYEAR;
      this.bTableProgram.items = [];
    },
    handleSelectProgram(data, idx) {
      this.programSelIdx = idx;
      this.txtProgramCode = data.PROGRAMCODE;
      this.txtProgramName = data.PROGRAMNAME;
      this.dialogSearchProgram = false;
      this.cleartSearchProgram();
    },
    cleartSearchProgram() {
      this.dlgProgramCode = "";
      this.dlgProgramName = "";
      this.selFacultyProgram = 0;
      this.selDepartmentProgram = 0;
      this.selLvlProgram = 3;
      this.selYearProgram = this.appInfo.data.ENROLL_ACADYEAR;
      this.bTableProgram.items = [];
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selAdmitYear = 0;
      this.selAdmitSemester = 0;
      this.selFaculty = 0;
      this.studentfrom = "";
      this.studentto = "";
      this.selectedYear = 0;
      this.txtProgramCode = "";
      this.txtProgramName = "";
      this.selCoursegroup = 0;
      this.selStudentStatusSearchFrom = 0;
      this.selStudentStatusSearchTo = 0;
      this.stucode = "";
      this.bTableStudent.items = [];
      this.bTableClsStudentByOne.items = [];
      this.bTablelistSetCls.items = [{ rowNumber: 0 }];
      this.clsId = "";
      this.reasonCls = "";
      this.ddlSection = [];
      this.ddlVal = -1;
      this.showListCondition();
    },
    async chkStudentCode(arrStudent) {
      this.togglePreLoader(true);
      const result = await enrollProvider.checkStudentCode({
        token: this.token,
        request: {
          studentlist: arrStudent.filter((a) => a != "").map((s) => +s),
          lang: this.currentLang,
        },
      });
      this.bTableStudent.items = [];
      if (result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          d.action = true;
          this.bTableStudent.items.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
      if (result.code == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.messagefordev}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}<br/>`;
      }
    },
    async handleSearchStudent() {
      if (
        this.selYear != 0 &&
        this.selSemester != 0 &&
        this.selLvl != -1 &&
        this.selAdmitYear != 0 &&
        this.selAdmitSemester != 0
      ) {
        this.togglePreLoader(true);
        const result = await enrollProvider.getEnrollregextra({
          token: this.token,
          request: {
            admitacadyear: this.selAdmitYear,
            admitsemester: this.selAdmitSemester,
            levelid: this.selLvl,
            studentyear: this.selectedYear,
            facultyid: this.selFaculty == 0 ? "" : this.selFaculty,
            departmentid: this.selDepartment == 0 ? "" : this.selDepartment,
            programid: this.txtProgramCode,
            studentidfrom: this.studentfrom,
            studentidto: this.studentto,
            statusfrom: this.selStudentStatusSearchFrom,
            statusto: this.selStudentStatusSearchTo,
            lang: this.currentLang,
          },
        });
        this.bTableStudent.items = [];
        if (result.length > 0) {
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTableStudent.items.push(d);
            idx++;
          });
          this.bTableClsStudentByOne.items = [];
        }
        this.togglePreLoader(false);
      }
    },
    async handleSelStudentCode(item, index) {
      this.togglePreLoader(true);
      const result = await enrollProvider.postPreEnrollRegExtraGetClass({
        token: this.token,
        request: {
          studentlist: [+item.STUDENTCODE],
          acadyear: this.selYear,
          semester: this.selSemester,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      this.bTableClsStudentByOne.items = [];
      if (result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableClsStudentByOne.items.push(d);
          idx++;
        });
        const temp1 = this.bTableClsStudentByOne.items.map((x) => {
          const found =
            result.data.find((r) => r.STUDENTID == x.STUDENTID) &&
            result.data.find((r) => r.COURSECODE == x.COURSECODE);
          const tmp = x;
          if (found) {
            tmp.SECTION_TEXT = found.SECTION;
          }
          return tmp;
        });
        this.bTableClsStudentByOne.items = temp1;

        const temp = this.bTableStudent.items.map((x) => {
          const found = result.data.find((r) => r.STUDENTID == x.STUDENTCODE);
          const tmp = x;
          if (found) {
            tmp.ERR_DESCSUBMIT = found.ERR_DESC;
          } else {
            tmp.ERR_DESCSUBMIT = "";
          }
          return tmp;
        });
        this.bTableStudent.items = temp;
      }
    },
    //add รายวิชาในตารางชุดรายการ
    async addCourse() {
      if (this.ddlVal > -1) {
        this.togglePreLoader(true);
        const req = {
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            coursegroup: this.selCoursegroup,
            facultyid: this.selFaculty,
            departmentid: this.selDepartment,
            lang: this.currentLang,
          },
        };
        const data = await classProvider.searchOpenCourse(req);
        if (data.length > 0) {
          const found = data.find(
            (d) =>
              d.COURSECODE == this.clsId && d.SECTION_TEXT == this.ddlSectionVal
          );
          if (found) {
            const resIp = await masterDataProvider.getCurrentIP();
            const temp = {
              token: this.token,
              request: {
                studentlist: this.bTableStudent.items.map(
                  (ii) => +ii.STUDENTCODE
                ),
                acadyear: this.selYear,
                semester: this.selSemester,
                classid: found.CLASSID,
                remark: this.reasonCls,
                action: this.ddlVal,
                userid: this.mfuUserId,
                createip: resIp.ip,
                lang: this.currentLang,
              },
            };
            this.togglePreLoader(false);
            const result = await enrollProvider.savePreEnrollRegExtra(temp);
            return result;
          }
        }
        this.togglePreLoader(false);
        return false;
      }
    },

    //ปุ่มลบรายวิชาในตารางชุดรายการ
    async delCourse(data) {
      console.log("data", data);
      this.togglePreLoader(true);
      const req = {
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          coursegroup: this.selCoursegroup,
          facultyid: this.selFaculty,
          departmentid: this.selDepartment,
          lang: this.currentLang,
        },
      };
      const result = await classProvider.searchOpenCourse(req);
      if (result.length > 0) {
        const found = result.find(
          (d) =>
            d.COURSECODE == data.CLASSID && d.SECTION_TEXT == data.SECTION_TEXT
        );
        console.log("found", found);
        if (found) {
          const res = await enrollProvider.deletePreEnrollRegExtraDetail({
            token: this.token,
            request: {
              studentlist: this.bTableStudent.items.map(
                (ii) => +ii.STUDENTCODE
              ),
              classid: found.CLASSID,
              userid: this.mfuUserId,
              lang: this.currentLang,
            },
          });
          this.togglePreLoader(false);
          return res;
        }
      }
      this.togglePreLoader(false);
      return false;
    },
    //ปุ่มดึงรายวิชา
    async pullCourse() {
      let errorMsg = "";
      this.togglePreLoader(true);
      const result = await enrollProvider.postPreEnrollregextragetclassreserve({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          studentlist: this.bTableStudent.items.map((ii) => +ii.STUDENTCODE),
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      this.bTableClsStudentByOne.items = [];
      if (result.code == 200) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableClsStudentByOne.items.push(d);
          idx++;
        });
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${errorMsg}`;
      }
    },
    //ปุ่มทำรายการ
    async regisClsList() {
      this.togglePreLoader(true);
      const resIp = await masterDataProvider.getCurrentIP();
      const temp = {
        token: this.token,
        request: {
          studentlist: this.bTableStudent.items.map((ii) => +ii.STUDENTCODE),
          acadyear: this.selYear,
          semester: this.selSemester,
          action: "0",
          usertype: this.appInfo.data.USER_TYPE,
          method: "X",
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.savePreEnrollRegExtraCon(temp);
      if (result.code == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}: ${result.messagefordev}<br/>`;
        this.bTablelistSetCls.items = [{ rowNumber: 0 }];
        this.showListCondition();
        const temp = this.bTableStudent.items.map((x) => {
          const found = result.data.find((r) => r.STUDENTID == x.STUDENTCODE);
          const tmp = x;
          if (found) {
            tmp.ERR_DESCSUBMIT = found.ERR_DESC;
          }
          return tmp;
        });
        this.bTableStudent.items = temp;

        const temp1 = this.bTableClsStudentByOne.items.map((x) => {
          const found =
            result.data.find((r) => r.STUDENTID == x.STUDENTID) &&
            result.data.find((r) => r.COURSECODE == x.COURSECODE);
          const tmp = x;
          if (found) {
            tmp.ERR_DESC_ITEM = found.ERR_DESC_ITEM;
          }
          return tmp;
        });

        this.bTableClsStudentByOne.items = temp1;
      } else {
        //this.handleCheck();
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = result.message
          ? `${result.message} : ${result.messagefordev}`
          : "code : 500";
        const temp = this.bTableStudent.items.map((x) => {
          const found = result.data.find((r) => r.STUDENTID == x.STUDENTCODE);
          const tmp = x;
          if (found) {
            tmp.ERR_DESCSUBMIT = found.ERR_DESC;
          }
          return tmp;
        });
        this.bTableStudent.items = temp;

        const temp1 = this.bTableClsStudentByOne.items.map((x) => {
          const found =
            result.data.find((r) => r.STUDENTID == x.STUDENTID) &&
            result.data.find((r) => r.COURSECODE == x.COURSECODE);
          const tmp = x;
          if (found) {
            tmp.ERR_DESC_ITEM = found.ERR_DESC_ITEM;
          }
          return tmp;
        });

        this.bTableClsStudentByOne.items = temp1;
      }
      this.togglePreLoader(false);
    },

    //แสดงข้อมูลเงื่อนไขในระบบ
    async showListCondition() {
      this.togglePreLoader(true);
      this.bTableConditionsCtrlEnroll.items = [];
      await this.getConditionlist();
      this.bTableConditionsCtrlEnroll.items = this.masterConditionList;
      this.togglePreLoader(false);
    },
    async getConditionlist() {
      this.togglePreLoader(true);
      const result = await enrollProvider.getconditionlist({
        token: this.token,
        request: {
          lang: this.currentLang,
        },
      });
      this.masterConditionList = [];
      if (result.length > 0) {
        let idx = 0;
        result.map((d) => {
          d.rowNumber = idx + 1;
          d.ERROR_DETAIL = d.ERROR_DETAIL == null ? "" : d.ERROR_DETAIL;
          this.masterConditionList.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    handleCondtionChk(e, data) {
      console.log("data", data);
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableConditionsCtrlEnroll.items[index].action = isChecked;
      if (isChecked) {
        this.confirmResultCondition(item);
      } else {
        this.cancelCondition(item);
      }
    },
    handleTxtStuKeyChange(event, data) {
      console.log("data.item", data.item);
      console.log("data.index", data.index);
      const rowNumber = data.item.rowNumber;
      if (
        (event.keyCode == 9 || event.keyCode == 40) &&
        rowNumber < this.bTableStudent.items.length
      ) {
        console.log("next", rowNumber);
        console.log("next item", this.bTableStudent.items[rowNumber]);
        setTimeout(() => {
          this.$refs[`ref_txtStudentCode_${rowNumber + 1}`].focus();
          // this.handleSelStudentCode(
          //   this.bTableStudent.items[rowNumber],
          //   rowNumber
          // );
        }, 50);
      } else if (event.keyCode == 38 && rowNumber > 1) {
        console.log("back", rowNumber - 2);
        console.log("back item", this.bTableStudent.items[rowNumber - 2]);
        setTimeout(() => {
          this.$refs[`ref_txtStudentCode_${rowNumber - 1}`].focus();
          // this.handleSelStudentCode(
          //   this.bTableStudent.items[rowNumber - 2],
          //   rowNumber - 2
          // );
        }, 50);
      }
    },
    //การบันทึกเงื่อนไข
    async confirmResultCondition(item) {
      this.togglePreLoader(true);
      const req = {
        token: this.token,
        request: {
          studentidlist: this.bTableStudent.items.map((ii) => +ii.STUDENTCODE),
          erroridlist: [item.ERRORID],
          courseid1: "",
          courseid2: "",
          creditmin: "",
          creditmax: "",
          classid1: "",
          classid2: "",
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.postAdjustConditionList(req);
      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      this.togglePreLoader(false);
    },
    //การลบ/ยกเลิกเงื่อนไข
    async cancelCondition(item) {
      this.togglePreLoader(true);
      const req = {
        token: this.token,
        request: {
          studentidlist: this.bTableStudent.items.map((ii) => +ii.STUDENTCODE),
          erroridlist: [item.ERRORID],
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.delConditionlist(req);
      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      this.togglePreLoader(false);
    },
    async loadDdl() {
      this.togglePreLoader(true);
      const req = {
        token: this.token,
        request: {
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.getaction(req);
      this.togglePreLoader(false);
      this.ddlItem = result;
    },
    async handleSearchOpenCourse(event, item) {
      if (event.keyCode == 13 || event.keyCode == 9) {
        const req = {
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            coursegroup: this.selCoursegroup,
            facultyid: this.selFaculty,
            departmentid: this.selDepartment,
            lang: this.currentLang,
          },
        };
        const data = await classProvider.searchOpenCourse(req);
        if (data.length > 0) {
          this.ddlSection = [];
          const tmp = this.bTablelistSetCls.items.map((b, idx) => {
            const found = data.filter((d) => d.COURSECODE == this.clsId);
            if (b.rowNumber == 0 && found.length > 0) {
              const tmpSection = found.map((f) => {
                return {
                  txt: f.SECTION_TEXT,
                  val: f.SECTION_TEXT,
                };
              });
              this.ddlSection = tmpSection;
              return {
                ...b,
                COURSENAME: found[0].COURSENAME,
                COURSEUNIT: found[0].COURSEUNIT,
                CREDITTOTAL: found[0].CREDITTOTAL,
                SECTION_TEXT: found[0].SECTION_TEXT,
              };
            } else {
              return b;
            }
          });
          this.bTablelistSetCls.items = tmp;
        }
      }
    },
    async handleAddItem(item, idx) {
      if (this.bTableStudent.items.length == 0 || this.clsId == "") {
        return;
      }
      const result = await this.addCourse();
      if (result && result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
      } else {
        if (result) {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = result.message ? `${result.message}` : "code : 500";
        }
        return;
      }
      const newLst = [
        {
          rowNumber: 0,
        },
      ];
      const tmpDdlVal = this.ddlItem.find((d) => d.BYTECODE == this.ddlVal);
      const tmp = this.bTablelistSetCls.items.map((t) => {
        if (t.rowNumber == 0) {
          return {
            ...t,
            rowNumber: t.rowNumber + 1,
            LVL: this.selLvl,
            ACTION_STATUS: tmpDdlVal.ACTION,
            CLASSID: this.clsId,
            REASON_TEXT: this.reasonCls,
            // CREDITTOTAL: this.txtCredittotal,
            // SECTION_TEXT: this.txtGroup,
          };
        } else {
          return {
            ...t,
            rowNumber: t.rowNumber + 1,
          };
        }
      });
      this.bTablelistSetCls.items = [];
      this.bTablelistSetCls.items = newLst.concat(tmp);
      this.clsId = "";
      this.reasonCls = "";
      this.txtCredittotal = "";
      this.txtGroup = "";
      this.ddlSection = [];
      this.ddlSectionVal = "";
    },
    async handleDelItem(item, idx) {
      if (this.bTableStudent.items.length == 0) {
        return;
      }
      const res = await this.delCourse(item);
      if (res && res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
      } else {
        if (res) {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `${res.message}<br/>`;
        }
        return;
      }
      const tmp = this.bTablelistSetCls.items.filter(
        (t) => t.rowNumber != item.rowNumber
      );
      this.bTablelistSetCls.items = [];
      this.bTablelistSetCls.items = tmp;
    },
    handleLastField(event, item, idx) {
      if (event.keyCode == 13 || event.keyCode == 9) {
        this.handleAddItem(item, idx);
      }
    },
    async handleCsvFileChg(e) {
      var file = e.target.files[0];
      const data = await file.arrayBuffer();
      const workbook = read(data);
      if (workbook && workbook.SheetNames.length > 0) {
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const sheetJson = utils.sheet_to_json(worksheet);
        if (sheetJson) {
          const studentIdList = sheetJson.map((s) => {
            var keyNames = Object.keys(s);
            return s[keyNames[0]];
          });
          console.log("studentIdList", studentIdList);
          this.chkStudentCode(studentIdList);
        }
      }
    },
  },
  watch: {
    async currentLang() {
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "PROGRAMCODE",
          label: this.$t("messages.general.programcode"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "PROGRAMNAME",
          label: this.$t("messages.general.programName"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "PROGRAMYEAR",
          label: this.$t("messages.general.yearRef"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableStudent.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          // thStyle: "width: 50px",
          sortable: true,
          tdClass: "col-30",
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 130px",
          tdClass: "text-center col-50",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left col-200",
          sortable: true,
        },
        {
          key: "ERR_DESCSUBMIT",
          label: this.$t("messages.general.errorList"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
      ];
      this.bTableClsStudentByOne.fields = [
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "SECTION_TEXT",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
        {
          key: "ERR_DESC_ITEM",
          label: this.$t("messages.general.errorList"),
          thClass: "align-left",
          thStyle: "width: 200px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
      ];
      this.bTablelistSetCls.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 90px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "LVL",
          label: this.$t("messages.general.level"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-50",
          sortable: true,
        },
        {
          key: "ACTION_STATUS",
          label: this.$t("messages.general.setListCls"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-150",
          sortable: true,
        },
        {
          key: "CLASSID",
          label: this.$t("messages.general.code"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-120",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.courseName"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.cretditSub"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-100",
          sortable: true,
        },
        {
          key: "CREDITTOTAL",
          label: this.$t("messages.general.regisCredit"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-90",
          sortable: true,
        },
        {
          key: "SECTION_TEXT",
          label: this.$t("messages.general.groupsec"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-90",
          sortable: true,
        },
        {
          key: "REASON_TEXT",
          label: this.$t("messages.general.reason"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-90",
          sortable: true,
        },
      ];
      this.bTableConditionsCtrlEnroll.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "ERRORID",
          label: this.$t("messages.general.idCondition"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "ERRORSTRING",
          label: this.$t("messages.general.condition"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 80px",
          sortable: true,
        },
      ];
      this.selectedYearOpts = [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
      ];
      this.selectedCourseGroupOpts = [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10", value: 10 },
        { text: "11", value: 11 },
        { text: "12", value: 12 },
        { text: "13", value: 13 },
        { text: "14", value: 14 },
        { text: "15", value: 15 },
        { text: "16", value: 16 },
        { text: "17", value: 17 },
        { text: "18", value: 18 },
        { text: "19", value: 19 },
        { text: "20", value: 20 },
        { text: "21", value: 21 },
        { text: "22", value: 22 },
        { text: "23", value: 23 },
        { text: "24", value: 24 },
        { text: "25", value: 25 },
        { text: "26", value: 26 },
        { text: "27", value: 27 },
        { text: "28", value: 28 },
        { text: "29", value: 29 },
        { text: "30", value: 30 },
      ];
    },
  },
};
</script>
